"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var handleCurry_1 = require("./utils/handleCurry");
var object_1 = require("./object");
var function_1 = require("./function");
var description_1 = require("./utils/description");
var typeToPredicate_1 = require("./typeToPredicate");
var symbol_1 = require("./symbol");
var string_1 = require("./string");
function property(propertyName, predicate, object) {
    if (!symbol_1.default(propertyName) && !string_1.default(propertyName)) {
        throw new TypeError('Property must be a string or a symbol');
    }
    if (arguments.length < 2) {
        throw new Error('Too few arguments - 2 required');
    }
    if (!function_1.default(predicate)) {
        throw new TypeError('Predicate is not a function');
    }
    predicate = typeToPredicate_1.getPredicateForType(predicate) || predicate;
    return handleCurry_1.default.call(this, arguments, description_1.setDescription(function isPropertySatisfiesPredicateTest(value) {
        var args = Array.prototype.slice.call(arguments);
        // conersion to string is necessary until https://github.com/Microsoft/TypeScript/issues/1863 gets fixed
        args.splice(0, 1, object_1.default(value) ? value[propertyName] : undefined);
        return object_1.default(value) && predicate.apply(this, args);
    }, 'an object with property ' + (symbol_1.default(propertyName) ? propertyName.toString() : '"' + propertyName + '"') +
        ' of type: ' + description_1.getDescription(predicate)), 2);
}
exports.default = property;
